// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2PM8v","content":"WmIrw","actionLink":"_3_qQH"};


//////////////////
// WEBPACK FOOTER
// ./components/ErrorScreen/styles.scss
// module id = 688
// module chunks = 0